document.addEventListener('DOMContentLoaded', () => {
	// slick default setting
	let defaulsettings = {
		loop: true,
		speed: 700,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		navigation: {
			nextEl: '.swiper-prev',
			prevEl: '.swiper-next',
		},
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
	}

	// start slider default
	let allSwipper = []

	document.querySelectorAll('.swiper-slider').forEach((element, i) => {
		let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper): defaulsettings
		element.setAttribute(`data-swiper-${i}`, '')
		let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig)
		allSwipper[i] = swiper
	})

		//Custom Controls
		allSwipper.forEach((swiper) => {
			const { customcontrol } = swiper.passedParams;
	
			if (customcontrol) {
					const targetSelectors = customcontrol.split(",").map((s) => s.trim()).filter(Boolean);
					const targetSwipers = allSwipper.filter((s) =>
							targetSelectors.some((selector) => 
									selector.startsWith("#") ? s.el.id === selector.slice(1) : 
									selector.startsWith(".") ? s.el.classList.contains(selector.slice(1)) : 
									false
							)
					);
	
					if (targetSwipers.length) {
							swiper.controller.control = targetSwipers;
					}
			}
	});

	document.querySelectorAll('[data-swiper-goto]').forEach((item) => {
		const target = item.dataset.swiperGoto ? parseInt(item.dataset.swiperGoto) : 0
		const slider = item.dataset.swipertarget ? document.querySelector(item.dataset.swipertarget) : item.closest('.swiper-slider')
		item.addEventListener('click', (e) => {
			slider.swiper.slideTo(target)
			document.querySelectorAll(`[data-swiper-goto]`).forEach((itm) => itm.classList.remove('active'))
			item.classList.add('active')
		})
	})

	//Home top Content slider
	let swiperHomeContent = document.querySelector('.home-slider');
	if (swiperHomeContent) {
			const progressLine = document.querySelector('[data-progress]');
			let swiperHomer = new Swiper(swiperHomeContent, {
					speed: 800,
					effect: 'fade',
					fadeEffect: {
							crossFade: true,
					},
					autoplay: {
							delay: 7000,
							disableOnInteraction: false,
					},
					on: {
							slideChange() {
									let currentSlide = swiperHomer.slides[swiperHomer.activeIndex];
									let video = currentSlide.querySelector('.home-top-content__video');
									if (video) {
											video.play(); 
											video.addEventListener('loadeddata', () => {
													progressLine.classList.add('video');
													swiperHomer.params.autoplay.delay = video.duration * 1000;
													swiperHomer.autoplay.start(); 
											});
											progressLine.classList.add('video');
									} else {
											swiperHomer.params.autoplay.delay = 7000; 
											swiperHomer.autoplay.start(); 
											progressLine.classList.remove('video');
									}
							},
							autoplayTimeLeft(s, time, progress) {
									progressLine.style.setProperty(
											'width',
											Math.round(100 - progress * 100) + '%'
									);
							},
							
					},
			});

			
			let firstSlide = swiperHomer.slides[swiperHomer.activeIndex];
			let video = firstSlide.querySelector('.home-top-content__video');
			if (video) {
			
					swiperHomer.params.autoplay.delay = video.duration * 1000;
					video.play(); 
					progressLine.classList.add('video');
					swiperHomer.autoplay.start(); 

				video.addEventListener('ended', () => {
					swiperHomer.removeSlide(swiperHomer.activeIndex);
					swiperHomer.update(); 
			});
			}
			

	}

	//Big Slider
	if (document.querySelector('.big-slider') != null) {
		let slider_left = new Swiper(`.big-slider-left-swiper`, {
			loop: true,
			speed: 700,
			allowTouchMove: false,
			effect: 'creative',
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
		})

		let slider_middle = new Swiper(`.big-slider-middle-swiper`, {
			loop: true,
			speed: 700,
			navigation: {
				nextEl: '[data-bignext]',
				prevEl: '[data-bigprev]',
			},
			autoplay: {
				delay: 9000,
				disableOnInteraction: false,
			},
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			pagination: {
				el: '[data-gallerydots]',
				clickable: true,
			},
		})

		let slider_right = new Swiper(`.big-slider-right-swiper`, {
			loop: true,
			speed: 700,
			allowTouchMove: false,
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
		})

		if (window.innerWidth >= 700) {
			slider_middle.controller.control = [slider_right, slider_left]
		}
	}

	//Special Columns
	if (document.querySelector('.special-columns__slider') != null) {
		let slider_left = new Swiper(`.special-columns__slider`, {
			loop: true,
			speed: 700,
			autoplay: {
				delay: 7000,
				disableOnInteraction: false,
			},
			navigation: {
				nextEl: '[data-specialcolnext]',
				prevEl: '[data-specialcolprev]',
			},
			breakpoints: {
				640: {
					slidesPerView: 1,
				},
				768: {
					slidesPerView: 2,
				},
				1200: {
					slidesPerView: 4,
				},
			},
		})
	}

	//Reviews
	if (document.querySelector('.reviews__slider') != null) {
		let slider_left = new Swiper(`.reviews__slider`, {
			loop: true,
			speed: 700,
			navigation: {
				nextEl: '[data-reviewnext]',
				prevEl: '[data-reviewprev]',
			},
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
		})
	}

	//Gallery
	if (document.querySelector('.gallery-block') != null) {
		let gallery_main = new Swiper(`.gallery-swiper-main`, {
			loop: true,
			speed: 700,
			navigation: {
				nextEl: '[data-galleryprev]',
				prevEl: '[data-gallerynext]',
			},
		})

		let gallery_left = new Swiper(`.gallery-swiper-left`, {
			loop: true,
			speed: 700,
			allowTouchMove: false,
		})
		let gallery_middle = new Swiper(`.gallery-swiper-middle`, {
			loop: true,
			speed: 700,
			allowTouchMove: false,
		})
		let gallery_right = new Swiper(`.gallery-swiper-right`, {
			loop: true,
			speed: 700,
			allowTouchMove: false,
		})

		if (window.innerWidth >= 700) {
			gallery_main.controller.control = [
				gallery_right,
				gallery_middle,
				gallery_left,
			]
		}
	}
})
